enum EventTypeTitlesEnum {
    drawingNotifications = 7,
    tasksNotifications = 13,
}

export default EventTypeTitlesEnum;
